import React from 'react';
import PropTypes from 'prop-types';

import CSS from './styles.css';


const NoteEditorViews = ({ cancelNote, handleChange, isSaveDisabled, noteText, onKeyDown, saveNote, styles }) => {
  return (
    <section className={ CSS['container'] } style={ styles } tabIndex="0" onKeyDown={ onKeyDown }>
      <textarea className={ CSS['textarea'] }
        rows="3"
        autoFocus
        value={ noteText }
        onChange={ handleChange } />
      <div className={ CSS['actions'] }>
        <button className={ CSS['save'] }
          disabled={ isSaveDisabled }
          onClick={ saveNote } tabIndex="0">
          Save
        </button>
        <button className={ CSS['cancel'] } onClick={ cancelNote } tabIndex="0">
          Cancel
        </button>
      </div>
    </section>
  );
};

NoteEditorViews.propTypes = {
  cancelNote: PropTypes.func,
  handleChange: PropTypes.func,
  isSaveDisabled: PropTypes.bool,
  noteText: PropTypes.string,
  saveNote: PropTypes.func
};


export default NoteEditorViews;
